<div class="flex-container">
  <hw-healthcare-sidebar [useContext]="true" [activeTab]="'menu'"></hw-healthcare-sidebar>
  <nz-content class="page-content--header-inside">
    <hw-page-header header="integration.econ-01.response.header" class="page-header">
      <div class="content float-right" *ngIf="!referralLoading && !responseCancelled">
        <hw-button
          *ngIf="type === 'waitlist'"
          (click)="save()"
          label="core.btn.save"
          display="default"
          [loading]="saving">
        </hw-button>
        <hw-button (click)="confirm()" label="core.btn.confirm" [loading]="saving"></hw-button>
      </div>
    </hw-page-header>

    <div class="page-content__flex-cols-container" [style.flex-direction]="'column'">
      <div nz-row [nzGutter]="16" class="page-content--center">
        <nz-card nz-col [nzSpan]="16" class="card-simple">
          <div *ngIf="referralModified">
            <span style="color: red">
              {{ 'integration.econ-01.response.referral-data-changed' | translate }}
              (<a (click)="openDocument(dlReferral)">{{ referral.identifier.value }}</a>
              {{ referralModified | localDateTime }})
            </span>
          </div>
          <form nz-form [formGroup]="form">
            <nz-divider
              [nzText]="'integration.econ-01.response.decision' | translate"
              nzOrientation="left"></nz-divider>
            <div hw-form-row>
              <div *hw-form-col>
                <hw-form-item name="author" label="integration.econ-01.response.author" required>
                  <hw-practitioner-select
                    formControlName="author"
                    [allowClear]="false"
                    [autoSelect]="true"
                    [practitionerIds]="allowedPractitioners"></hw-practitioner-select>
                </hw-form-item>
              </div>
            </div>
            <div hw-form-row>
              <div *hw-form-col>
                <hw-form-item name="type" label="integration.econ-01.response.response-type" required>
                  <hw-concept-select
                    formControlName="type"
                    [filter]="eConsultFilter"
                    valueType="primitive"
                    codesystem="tis-e-consultation-response-type"></hw-concept-select>
                </hw-form-item>
                <hw-form-item
                  *ngIf="hasDecisionConcepts"
                  name="decision"
                  label="integration.econ-01.response.response-decision">
                  <hw-concept-select
                    formControlName="decision"
                    [filter]="decisionFilter"
                    valueType="primitive"
                    codesystem="consultation-decision"></hw-concept-select>
                </hw-form-item>
                <hw-form-item
                  name="cancellationReason"
                  *ngIf="showCancellationReason"
                  label="integration.econ-01.response.cancellation-reason"
                  required>
                  <hw-concept-select
                    formControlName="cancellationReason"
                    valueType="codeName"
                    codesystem="e-consultation-cancellation-reason"></hw-concept-select>
                </hw-form-item>
                <hw-form-item
                  name="comment"
                  label="integration.econ-01.response.description"
                  [required]="form.value.type === '01'">
                  <hw-textarea formControlName="comment" [autosize]="{ minRows: 1, maxRows: 6 }"></hw-textarea>
                </hw-form-item>
                <div *ngIf="type === 'waitlist' && appointments?.length > 0">
                  <a *ngFor="let app of appointments" (click)="addAppointmentData(app)">
                    {{ 'integration.econ-01.appointment.add' | translate }}
                    {{ 'integration.econ-01.appointment.prefix' | translate }} {{ app.valid?.lower | localDateTime }}
                  </a>
                </div>
                <div>
                  <hw-form-item
                    *ngIf="responseCompleted || responseDecisionLocked || form.value['additionalComment']?.length > 0"
                    name="additionalComment"
                    label="integration.econ-01.response.additional-info">
                    <hw-textarea
                      formControlName="additionalComment"
                      [autosize]="{ minRows: 1, maxRows: 6 }"></hw-textarea>
                  </hw-form-item>
                  <a
                    *ngIf="form.value['additionalComment']?.length > 0"
                    title="integration.econ-01.response.add-text"
                    nz-popconfirm
                    [nzPopconfirmTitle]="form.value['additionalComment'] | format : formatAdditionalCommentConfirmTitle"
                    (nzOnConfirm)="handleAdditionalComment()">
                    {{ 'integration.econ-01.response.add-text' | translate }}
                  </a>
                </div>
              </div>
            </div>

            <ng-container *ngIf="form.value.type && form.value.type !== '05'">
              <nz-divider
                [nzText]="'integration.econ-01.response.diagnosis' | translate"
                nzOrientation="left"></nz-divider>
              <div hw-form-row>
                <div *hw-form-col>
                  <hw-form-item name="diagnosis" label="integration.econ-01.response.rhk-code">
                    <hw-diagnosis-drawer-search
                      formControlName="diagnosis"
                      [classification]="'icd10'"></hw-diagnosis-drawer-search>
                  </hw-form-item>
                  <hw-form-item name="diagnosisText" label="integration.econ-01.response.text-diagnosis">
                    <textarea nz-input cols="80" formControlName="diagnosisText"></textarea>
                  </hw-form-item>
                  <hw-form-item
                    name="diagnosisRecurrence"
                    label="integration.econ-01.response.recurrence"
                    [required]="!!form.value.diagnosis">
                    <hw-codesystem-concept-radio
                      formControlName="diagnosisRecurrence"
                      codesystem="condition-recurrence"></hw-codesystem-concept-radio>
                  </hw-form-item>
                </div>
              </div>
            </ng-container>
            <nz-divider [nzText]="'integration.policy-provision.title' | translate" nzOrientation="left"></nz-divider>
            <div hw-form-row *ngIf="dlReferral">
              <hw-policy-provision-input
                formControlName="policy"
                [readonlyActors]="this.patientResponsePolicy ? ['patient'] : []"></hw-policy-provision-input>
            </div>
          </form>
        </nz-card>
        <hw-spinner nz-col [nzSpan]="8" *ngIf="referralLoading"></hw-spinner>
        <hw-response-referral-details
          nz-col
          [nzSpan]="8"
          [referral]="referral"
          [dlReferral]="dlReferral"
          *ngIf="!referralLoading && referral">
        </hw-response-referral-details>
      </div>
    </div>
  </nz-content>
</div>
